import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "salarii-wrapper" }
const _hoisted_2 = { class: "salarii-row sal-top-1" }
const _hoisted_3 = { class: "left-block" }
const _hoisted_4 = { class: "salarii-row sal-top-1" }
const _hoisted_5 = { style: {"padding":"15px"} }
const _hoisted_6 = { style: {"margin-bottom":"20px"} }
const _hoisted_7 = { style: {"display":"flex","gap":"10px","margin-top":"10px"} }
const _hoisted_8 = { style: {"display":"flex","gap":"10px","margin-top":"10px"} }
const _hoisted_9 = { style: {"margin-bottom":"20px"} }
const _hoisted_10 = { style: {"margin-bottom":"20px"} }
const _hoisted_11 = { style: {"text-align":"right","margin-top":"15px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxRadioGroup = _resolveComponent("DxRadioGroup")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxGroupItem = _resolveComponent("DxGroupItem")!
  const _component_DxTab = _resolveComponent("DxTab")!
  const _component_DxTabbedItem = _resolveComponent("DxTabbedItem")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[20] || (_cache[20] = _createElementVNode("label", { class: "lbl ml-1" }, "Data:", -1)),
        _createVNode(_component_DxSelectBox, {
          items: _ctx.luni,
          modelValue: _ctx.dataSelectata,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataSelectata) = $event)),
          "display-expr": "text",
          "value-expr": "value",
          width: "220",
          onValueChanged: _ctx.getAngajati
        }, null, 8, ["items", "modelValue", "onValueChanged"]),
        _createVNode(_component_DxSelectBox, {
          items: _ctx.ani,
          modelValue: _ctx.anulSelectat,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.anulSelectat) = $event)),
          "display-expr": "text",
          "value-expr": "value",
          width: "220",
          onValueChanged: _ctx.getAngajati
        }, null, 8, ["items", "modelValue", "onValueChanged"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[21] || (_cache[21] = _createElementVNode("label", { class: "lbl ml-1" }, "Angajati:", -1)),
      _createVNode(_component_DxRadioGroup, {
        items: ['Activi', 'Inactivi', 'Schimbare Loc Munca'],
        layout: "horizontal",
        modelValue: _ctx.modPreluare,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modPreluare) = $event)),
        onValueChanged: _ctx.onModeChanged
      }, null, 8, ["modelValue", "onValueChanged"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({ 'disabled-grid': _ctx.modPreluare === 'Companie' })
    }, [
      _createVNode(_component_DxDataGrid, {
        class: "salarii-grid",
        "data-source": _ctx.dsEmployees,
        "key-expr": "Id",
        "show-borders": true,
        "show-row-lines": true,
        "allow-column-reordering": true,
        "allow-column-resizing": true,
        "column-resizing-mode": 'nextColumn',
        "hover-state-enabled": true,
        "focused-row-index": 0,
        "column-auto-width": false,
        width: "100%",
        onSelectionChanged: _ctx.onSelectionChanged,
        onInitNewRow: _ctx.onInitNewRow
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DxSelection, { mode: "single" }),
          _createVNode(_component_DxFilterRow, { visible: true }),
          _createVNode(_component_DxSorting, { mode: "multiple" }),
          _createVNode(_component_DxPaging, { "page-size": 14 }),
          _createVNode(_component_DxSearchPanel, {
            visible: false,
            "search-visible-columns-only": true
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "InternalCode",
            caption: "Cod",
            width: "80"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Cnp",
            caption: "CNP"
          }),
          _createVNode(_component_DxColumn, {
            caption: "Nume Prenume",
            "calculate-cell-value": _ctx.calculateFullName,
            "calculate-filter-expression": _ctx.calculateFilterExpression,
            "min-width": 150,
            "allow-search": true
          }, null, 8, ["calculate-cell-value", "calculate-filter-expression"]),
          _createVNode(_component_DxColumn, {
            "data-field": "StructId",
            caption: "Departament"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxLookup, {
                "data-source": _ctx.dsDepartamente,
                "display-expr": "Name",
                "value-expr": "ID"
              }, null, 8, ["data-source"])
            ]),
            _: 1
          }),
          _createVNode(_component_DxToolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_DxItem, null, {
                default: _withCtx(() => [
                  _createVNode(_component_DxButton, {
                    icon: "add",
                    type: "success",
                    onClick: _ctx.onAddClick
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data-source", "onSelectionChanged", "onInitNewRow"]),
      _createVNode(_component_DxPopupAdd, {
        visible: _ctx.addPopupVisible,
        "show-title": true,
        height: 570,
        width: 840
      }, {
        title: _withCtx(() => [...(_cache[22] || (_cache[22] = [
          _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Adăugare ", -1)
        ]))]),
        default: _withCtx(() => [
          _createVNode(_component_DxForm, {
            "col-count": 1,
            "form-data": _ctx.formData,
            "label-alignment": "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxTabbedItem, {
                "tab-panel-options": _ctx.tabPanelOptions,
                "css-class": "tabs-two-rows"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxTab, {
                    title: _ctx.tabs[0]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxGroupItem, { "col-count": 3 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "InternalCode",
                            label: { text: 'Cod intern' },
                            "editor-options": {
                                    placeholder: '#AUTO',
                                    elementAttr: { class: 'internal-code-ph' }
                                },
                            "is-required": true
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Name",
                            label: { text: 'Nume' },
                            "is-required": true
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Surname",
                            label: { text: 'Prenume' },
                            "is-required": true
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Cnp",
                            label: { text: 'CNP' },
                            "is-required": true,
                            "editor-type": "dxTextBox",
                            "editor-options": {
                                        mask: '0000000000000',
                                        useMaskedValue: true,
                                        onValueChanged: _ctx.onCnpChanged
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Sex",
                            label: { text: 'Sex' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsGetAll?.Sex ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează'
                                    },
                            "is-required": true
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "BornDate",
                            "editor-type": "dxDateBox",
                            label: { text: 'Data Nașterii' },
                            "editor-options": { displayFormat: 'dd MMM yyyy' },
                            "is-required": true
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "EmpgroupId",
                            label: { text: 'Grup Angajati' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsGrupuri,
                                        valueExpr: 'ID',
                                        displayExpr: 'Nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează'
                                    },
                            "is-required": true
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "StructId",
                            label: { text: 'Departament' },
                            "col-span": 2,
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsDepartamente,
                                        valueExpr: 'ID',
                                        displayExpr: 'Name',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează',
                                        readOnly: !_ctx.isCnpValid
                                    },
                            "is-required": true
                          }, null, 8, ["editor-options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_component_DxTab, {
                    title: _ctx.tabs[1]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxGroupItem, { "col-count": 3 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DocIdentTip",
                            label: { text: 'Tip Act Identitate' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsGetAll?.DocIdentTip ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Carte Identitate'
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DocIdentSerie",
                            label: { text: 'Serie' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DocIdentNo",
                            label: { text: 'Numar' },
                            "editor-type": "dxTextBox",
                            "editor-options": {
                                        mask: '000000',
                                        useMaskedValue: true,

                                    }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DocIdentIssuer",
                            label: { text: 'Emitent' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DocIdentIssueDate",
                            "editor-type": "dxDateBox",
                            label: { text: 'Data Emiterii' },
                            "editor-options": {
                                        displayFormat: 'dd MMM yyyy',
                                        onValueChanged(e) {
                                            _ctx.formData.DocIdentIssueDate = e.value;
                                        }
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DocIdentExpiryDate",
                            "editor-type": "dxDateBox",
                            label: { text: 'Data Expirare' },
                            "editor-options": {
                                        displayFormat: 'dd MMM yyyy',
                                        min: _ctx.expiryMinDate
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            label: { text: 'Țara' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                    dataSource: _ctx.dsTari ?? [],
                                    valueExpr: 'ID',
                                    displayExpr: 'Nume',
                                    showClearButton: true,
                                    searchEnabled: true,
                                    placeholder: 'Selectează',
                                    value: _ctx.formData.BornCntryId,
                                    onValueChanged(e) {
                                        _ctx.formData.BornCntryId = e.value;
                                    }
                                }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            label: { text: 'Localitate' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                    dataSource: _ctx.dsLocalitati,
                                    valueExpr: 'ID',
                                    displayExpr(item) { return item ? `${item.CodSiruta}/Jud. ${item.Judet}/ ${item.Localitate}/ ${item.Sat}` : `` },
                                    showClearButton: true,
                                    searchEnabled: true,
                                    placeholder: 'Selectează',
                                    value: _ctx.formData.BornPlaceId,
                                    onValueChanged(e) {
                                        _ctx.formData.BornPlaceId = e.value;
                                    }
                                },
                            "col-span": 2
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "col-span": 3,
                            label: { text: 'Adresa Domiciliu' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsAdrese,
                                        valueExpr: 'ID',
                                        displayExpr: 'Adresa1',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează',

                                        value: _ctx.formData.AddressId,

                                        onValueChanged: (e) => {
                                            _ctx.formData.AddressId = e.value;
                                        },

                                        onOpened: (e) => {
                                            e.component.close();
                                            _ctx.popupAdreseVisible = true;
                                        }
                                    }
                          }, null, 8, ["editor-options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_component_DxTab, {
                    title: _ctx.tabs[2]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxGroupItem, { "col-count": 3 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSimpleItem, {
                            label: { text: 'Meserie/Profesie' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsMeserii,
                                        valueExpr: 'ID',
                                        displayExpr(item) { return item ? `${item.code}/${item.name}` : `` },
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează',
                                        value: _ctx.formData.MeserieId,
                                        onValueChanged(e) {
                                            _ctx.formData.MeserieId = e.value;
                                        }
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "NrCrtOrg",
                            label: { text: 'Nr. Crt. Organigrama' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            label: { text: 'Funcție (Post)' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsPositions,
                                        valueExpr: 'ID',
                                        displayExpr: 'name',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează',
                                        value: _ctx.formData.PositionId,
                                        onValueChanged(e) {
                                            _ctx.formData.PositionId = e.value;
                                        }
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "WorkGrade",
                            label: { text: 'Grupa de Muncă' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsGetAll?.WorkGrade ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează'
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "FunctieDeBaza",
                            "editor-type": "dxSwitch",
                            label: { text: 'Funcție de bază' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Pensionar",
                            label: { text: 'Este Pensionar? ' },
                            "editor-type": "dxSwitch"
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "OreContract",
                            label: { text: 'Ore Contract' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "ZileConc",
                            label: { text: 'Zile Concediu' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "StudiesLevel",
                            label: { text: 'Nivel Studii' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsGetAll?.StudiesLevel ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează'
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "MrtStatus",
                            label: { text: 'Stare Civila' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsGetAll?.Mrt ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează'
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DrvLicense",
                            label: { text: 'Permis Auto' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsGetAll?.DrvLicense ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: '[fără]'
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Vechime",
                            label: { text: 'Vechime Calculat' },
                            "editor-options": { readOnly: true, placeholder: '#AUTO' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Observations",
                            label: { text: 'Observatii' },
                            "col-span": 3
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_component_DxTab, {
                    title: _ctx.tabs[3]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxGroupItem, { "col-count": 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "TransferInRevisal",
                            "editor-type": "dxSwitch",
                            label: { text: 'Transfer In Revisal' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Apatrid",
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsGetAll?.Apatrid ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            label: { text: 'Nationalitate' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsNationalitate,
                                        valueExpr: 'ID',
                                        displayExpr: 'Nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'România',
                                        value: _ctx.formData.TaraNationalitateId,
                                        onValueChanged(e) {
                                            _ctx.formData.TaraNationalitateId = e.value;
                                        }
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "Mentiuni",
                            label: { text: 'Mentiuni' }
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_component_DxTab, {
                    title: _ctx.tabs[4],
                    disabled: _ctx.detaliiStrainDisabled
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxGroupItem, { "col-count": 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "TipAutorizatie",
                            label: { text: 'Tip Autorizatie' },
                            "col-span": 2,
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsGetAll?.TipAutorizatie ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează'
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "editor-type": "dxDateBox",
                            label: { text: 'Data Inceput Autorizatie' },
                            "editor-options": {
                                        displayFormat: 'dd MMM yyyy',
                                        readOnly: _ctx.isReadonlyTipAuorizatie,
                                        onValueChanged(e) {
                                            _ctx.formData.DataInceputAutorizatie = e.value;
                                        }
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataSfarsitAutorizatie",
                            "editor-type": "dxDateBox",
                            label: { text: 'Data Sfarsit Autorizatie' },
                            "editor-options": {
                                        displayFormat: 'dd MMM yyyy',
                                        min: _ctx.expiryDate,
                                        readOnly: _ctx.isReadonlyTipAuorizatie,
                                    }
                          }, null, 8, ["editor-options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title", "disabled"]),
                  _createVNode(_component_DxTab, {
                    title: _ctx.tabs[5]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxGroupItem, { "col-count": 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "CasaSn",
                            label: { text: 'Casa Asigurari Sanatate' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsGetAll?.CasaSn ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                       
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "D112TipAsigurat",
                            label: { text: 'Tip Asigurat(A, B)' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsGetAll?.D112_TipAsigurat ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Salariat'
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "D112AsigScu",
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                    dataSource: _ctx.dsGetAll?.D112_AsigScu ?? [],
                                    valueExpr: 'cod',
                                    displayExpr: 'nume',
                                    showClearButton: true,
                                    searchEnabled: true,
                                    placeholder: 'Fără scutire'
                                },
                            label: { text: 'Scutire plata impozit pe venit: tip persoana' },
                            "col-span": 2
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "D112AsigCi",
                            "editor-type": "dxSwitch",
                            label: { text: 'Asigurat pentru concedii si indemnizatii de asigurari sociale de sanatate' },
                            "col-span": 2
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "D112AsigSo",
                            "editor-type": "dxSwitch",
                            label: { text: 'Asigurat in sistemul de asigurari pt somaj' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "D112AsigExc",
                            "editor-type": "dxSwitch",
                            label: { text: 'Persoana exceptatat de la plata CAS si CASS' }
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_component_DxTab, {
                    title: _ctx.tabs[6]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxGroupItem, { "col-count": 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "CardSalary",
                            label: { text: 'Are Card?' },
                            "editor-type": "dxSwitch"
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "CardNo",
                            label: { text: 'Numar' },
                            "editor-options": {
                                    mask: '0000000000000000',
                                    useMaskedValue: true,
                                    readOnly: _ctx.isReadonly
                                }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            label: { text: 'Banca' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                    dataSource: _ctx.dsBanci,
                                    valueExpr: 'ID',
                                    displayExpr: 'Nume',
                                    showClearButton: true,
                                    searchEnabled: true,
                                    placeholder: 'Selectează',
                                    value: _ctx.formData.CardBankId,
                                    onValueChanged(e) {
                                        _ctx.formData.CardBankId = e.value;
                                    },

                                }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "CardAccNo",
                            label: { text: 'Cont' }
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_component_DxTab, {
                    title: _ctx.tabs[7]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxGroupItem, { "col-count": 3 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "PontajOraInceput",
                            label: { text: 'Oră început program' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "PontajPauzaMinute",
                            label: { text: 'Durată pauză de masă (minute)' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            label: { text: 'Vizibil pentru: ' },
                            "editor-type": "dxSelectBox",
                            "editor-options": {
                                        dataSource: _ctx.dsStructura,
                                        valueExpr: 'Id',
                                        displayExpr: 'Nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează',
                                        value: _ctx.formData.StructuraId,
                                        onValueChanged(e) {
                                            _ctx.formData.StructuraId = e.value;
                                        }
                                    }
                          }, null, 8, ["editor-options"]),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "PontajUsrId",
                            "editor-type": "dxTextBox",
                            label: { text: 'User ID - Sistem Pontaj' },
                            "col-span": 3
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_component_DxTab, {
                    title: _ctx.tabs[8]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxGroupItem, { "col-count": 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "SalBaza",
                            label: { text: 'Salariu de baza' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            label: { text: 'Somer unic sustinator fam. monoparentala' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            label: { text: 'Somer peste 45 ani ' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            label: { text: 'Avans suma fixa ' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            label: { text: 'Primeste bonuri de masa' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            label: { text: 'Suma Spor Weekend' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            label: { text: 'Calcul Contributii CAS, CASS la Sal Min' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            label: { text: 'Motiv exceptare CAS, CASS Sal Min' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: 'Numar copii inscrisi invatamant(OG.16/2022-art.77.10b)-deducere supl.' }
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_component_DxTab, {
                    title: _ctx.tabs[9]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxGroupItem, { "col-count": 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "salBaza",
                            label: { text: 'Conventie Grupare' },
                            "col-span": 2
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            label: { text: 'Conventie Somaj Data ' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: 'Conventie Somaj Nr ' }
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_component_DxTab, {
                    title: _ctx.tabs[10],
                    "css-class": "tab-venituri"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxGroupItem, { "col-count": 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: ' 8.4.0 Alte drepturi neimpozitabile, cf.art.76 alin.(4) din CF (necategorisite mai jos)****' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: ' 8.4.1 Indemnizatii de delegare neimpozitabile, cf.art.76 alin.(4) lit.h) din CF***' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: ' 8.4.2 Indemnizatii de detasare neimpozitabile, cf.art.76 alin.(4) lit.h) din CF****' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: ' 8.4.3 Indemnizatii specifice detasarii transnationale neimpozitabile, cf.art.76 alin.(4) lit.h) din CF****' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: ' 8.4.4 Prestatii suplimentare primite de salariati in baza clauzei de mobilitate neimpozabile, cf.art.76 alin.(2) si alin.(4) lit.a) din CF	****' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: ' 8.4.5 Avantajele sub forma dreptului la stock options plan, la momentul acordarii si la momentul exercitarii acestora, cf.art.76 alin.(4) lit.r) din CF	****' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: ' 8.4.6 Contributiile la un fond de pensii facultative(L.204/2006), suportate de angajator pentru angajatii proprii, in limita a 400 euro/an/persoana, cf.art.76alin.(4^1) lit.e) din CF	****' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: ' 8.4.7 Primele de asigurare voluntara de sanatate precum si serviciile medicale furnizate sub forma de abonament, suportate de angajator pentru angajatii proprii, in limita a 400 euro/an/persoana, cf.art.76 alin.(4^1) lit.f) din CF	****' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: ' 8.4.8 C/val serv. turistice si/sau de tratament (+transportul), pe perioada CO, acordate de angajator pentru salariatii proprii, cf. CIM sau in regulamentul intern, cf.art.76 alin.(4^1) lit.d) din CF	****' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: ' 8.4.9 C/val ab. pentru utilizarea facilitatilor sportive, suportate de angajator, in limita a 400 euro/an/persoana, cf.art. 76 alin. 4^1 lit. h) din CF	****' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: ' 8.4.10 C/val hranei acordate de catre angajator pentru angajatii proprii, cf. art. 76 alin. 4^1 lit. b) din CF	****' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: ' 8.4.11 Cazarea si contravaloarea chiriei pentru spatiile de cazare/de locuit puse de catre angajatori la dispozitia angajatilor propriii, cf. art.76 alin. 4^1 lit. c) din CF	****' }
                          }),
                          _createVNode(_component_DxSimpleItem, {
                            "data-field": "DataInceputAutorizatie",
                            "col-span": 2,
                            label: { text: ' 8.4.12 Sumele acordate angajatilor care desfasoara activitati in regim de telemunca, cf. art. 76 alin.4^1 lit. g) din CF		****' }
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              }, 8, ["tab-panel-options"])
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createVNode(_component_DxToolbarItem, {
            toolbar: "bottom",
            location: "after",
            widget: 'dxButton',
            options: {
                    text: 'Salvează',
                    type: 'success',
                    stylingMode: 'contained',
                    onClick: _ctx.submitForm,
                    width: 110,
                    height: 32
                }
          }, null, 8, ["options"]),
          _createVNode(_component_DxToolbarItem, {
            toolbar: "bottom",
            location: "after",
            widget: 'dxButton',
            options: {
                    text: 'Închide',
                    type: 'danger',
                    stylingMode: 'contained',
                    onClick: _ctx.closePopup,
                    width: 110,
                    height: 32
                }
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_DxPopupAdd, {
        visible: _ctx.popupAdreseVisible,
        "show-title": true,
        title: "Selectare adresa",
        width: 840,
        height: 680,
        onHiding: _cache[19] || (_cache[19] = ($event: any) => (_ctx.popupAdreseVisible = false))
      }, {
        title: _withCtx(() => [...(_cache[23] || (_cache[23] = [
          _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Selectează adresa ", -1)
        ]))]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[24] || (_cache[24] = _createElementVNode("h4", { style: {"font-weight":"800","margin-bottom":"10px","border-bottom":"2px solid #ff2c21","padding-bottom":"6px","color":"#ff2c21"} }, " Adresa ", -1)),
              _createVNode(_component_DxSelectBox, {
                "data-source": _ctx.dsGetAll?.TipAdresa,
                "display-expr": "nume",
                "value-expr": "cod",
                placeholder: "Tip",
                "search-enabled": true,
                value: _ctx.dataAdress.TipCod,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataAdress.TipCod) = $event))
              }, null, 8, ["data-source", "value"]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_DxTextBox, {
                  placeholder: "Strada",
                  style: {"margin-top":"10px","flex":"2"},
                  value: _ctx.dataAdress.Strada,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataAdress.Strada) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_DxTextBox, {
                  placeholder: "StradaNr",
                  style: {"margin-top":"10px","flex":"1"},
                  value: _ctx.dataAdress.StradaNr,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataAdress.StradaNr) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_DxTextBox, {
                  placeholder: "Bloc",
                  style: {"margin-top":"10px","flex":"1"},
                  value: _ctx.dataAdress.Bloc,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataAdress.Bloc) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_DxTextBox, {
                  placeholder: "Scara",
                  style: {"margin-top":"10px","flex":"1"},
                  value: _ctx.dataAdress.Scara,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dataAdress.Scara) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_DxTextBox, {
                  placeholder: "Etaj",
                  style: {"margin-top":"10px","flex":"1"},
                  value: _ctx.dataAdress.Etaj,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dataAdress.Etaj) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_DxTextBox, {
                  placeholder: "Apartament",
                  style: {"margin-top":"10px","flex":"2"},
                  value: _ctx.dataAdress.Apartament,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dataAdress.Apartament) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_DxTextBox, {
                  placeholder: "CodPostal",
                  style: {"margin-top":"10px","flex":"2"},
                  value: _ctx.dataAdress.CodPostal,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dataAdress.CodPostal) = $event))
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_DxSelectBox, {
                  "data-source": _ctx.dsTari,
                  "display-expr": "Nume",
                  "value-expr": "ID",
                  placeholder: "Țara",
                  "search-enabled": true,
                  value: _ctx.dataAdress.TaraID,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dataAdress.TaraID) = $event)),
                  onValueChanged: _ctx.onTaraChanged
                }, null, 8, ["data-source", "value", "onValueChanged"]),
                _createVNode(_component_DxSelectBox, {
                  "data-source": _ctx.dsJudete,
                  "display-expr": "Nume",
                  "value-expr": "ID",
                  placeholder: "Județ",
                  "search-enabled": true,
                  value: _ctx.dataAdress.JudetID,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dataAdress.JudetID) = $event)),
                  onValueChanged: _ctx.onJudetChanged,
                  disabled: !_ctx.dataAdress.TaraID
                }, null, 8, ["data-source", "value", "onValueChanged", "disabled"]),
                _createVNode(_component_DxSelectBox, {
                  "data-source": _ctx.dsLocalitati,
                  "display-expr": "Localitate",
                  "value-expr": "ID",
                  placeholder: "Localitate",
                  "search-enabled": true,
                  value: _ctx.localitateId,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.localitateId) = $event)),
                  onValueChanged: _ctx.onLocalitateChanged,
                  disabled: !_ctx.dataAdress.JudetID
                }, null, 8, ["data-source", "value", "onValueChanged", "disabled"]),
                _createVNode(_component_DxSelectBox, {
                  "data-source": _ctx.dsLocalitati,
                  "display-expr": "Sat",
                  "value-expr": "ID",
                  placeholder: "Sat",
                  "search-enabled": true,
                  value: _ctx.satId,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.satId) = $event)),
                  onValueChanged: _ctx.onSatChanged,
                  disabled: !_ctx.localitateId
                }, null, 8, ["data-source", "value", "onValueChanged", "disabled"])
              ]),
              _createVNode(_component_DxTextBox, {
                placeholder: "Cod SIRUTA",
                style: {"margin-top":"10px"},
                value: _ctx.codSiruta,
                "read-only": true
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[25] || (_cache[25] = _createElementVNode("h4", { style: {"font-weight":"800","margin-bottom":"10px","border-bottom":"2px solid #ff2c21","padding-bottom":"6px","color":"#ff2c21"} }, " Profesional ", -1)),
              _createVNode(_component_DxTextBox, {
                placeholder: "Telefon",
                value: _ctx.dataAdress.Telefon,
                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dataAdress.Telefon) = $event)),
                "show-spin-buttons": false,
                "show-clear-button": true,
                min: 0,
                format: '#0'
              }, null, 8, ["value"]),
              _createVNode(_component_DxTextBox, {
                placeholder: "Email (acces Portal HR)",
                style: {"margin-top":"10px"},
                value: _ctx.dataAdress.Email,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dataAdress.Email) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[26] || (_cache[26] = _createElementVNode("h4", { style: {"font-weight":"800","margin-bottom":"10px","border-bottom":"2px solid #ff2c21","padding-bottom":"6px","color":"#ff2c21"} }, " Personal ", -1)),
              _createVNode(_component_DxTextBox, {
                placeholder: "Telefon",
                value: _ctx.dataAdress.TelefonPersonal,
                "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.dataAdress.TelefonPersonal) = $event)),
                "show-spin-buttons": false,
                "show-clear-button": true,
                min: 0,
                format: '#0'
              }, null, 8, ["value"]),
              _createVNode(_component_DxTextBox, {
                placeholder: "Email",
                style: {"margin-top":"10px"},
                value: _ctx.dataAdress.EmailPersonal,
                "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dataAdress.EmailPersonal) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_DxButton, {
                text: "Aplică",
                type: "default",
                style: {"height":"32px","font-size":"13px","padding":"2px 10px","width":"110px","margin-right":"10px"},
                onClick: _ctx.applyAddress
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                type: "danger",
                style: {"height":"32px","font-size":"13px","padding":"2px 10px","width":"110px"},
                onClick: _ctx.closePopupAdrese
              }, null, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ], 2)
  ]))
}